import React, { ComponentType } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { MeasurementFlowScreen, HomeScreen, MeasurementSubmitFormScreen, DrugIntakeFlowScreen, DrugIntakeSubmitFormScreen, ActivitySuccessScreen, QuestionnaireFlowScreen, RemeasurementStartScreen, RemeasurementSuccessScreen, WhoMeasuredScreen, AlertEscalationScreen, WherebyRoomScreen, TeleassistanceDetailScreen } from './CoreScreens';
import { TNavigationStack } from 'app/types';
import { colorPalette } from '@shared/config/colorsConfig';

type ScreenConfig = { name: keyof TNavigationStack; component: ComponentType<any>; options: object };

const Stack = createNativeStackNavigator<TNavigationStack>();

const CORE_SCREENS: ScreenConfig[] = [{
  name: 'Homepage',
  component: HomeScreen,
  options: { headerShown: false }
}, {
  name: 'MeasurementFlow',
  component: MeasurementFlowScreen,
  options: { headerShown: false, title: 'Activity Introduction' }
}, {
  name: 'MeasurementSubmit',
  component: MeasurementSubmitFormScreen,
  options: { headerShown: false, title: 'Measurement Submit' }
}, {
  name: 'DrugIntakeFlow',
  component: DrugIntakeFlowScreen,
  options: { headerShown: false, title: 'Drug Intake' }
}, {
  name: 'DrugIntakeSubmit',
  component: DrugIntakeSubmitFormScreen,
  options: { headerShown: false, title: 'Drug Intake Submit' }
}, {
  name: 'QuestionnaireFlow',
  component: QuestionnaireFlowScreen,
  options: { headerShown: false, title: 'Questionnaire Flow' }
}, {
  name: 'ActivitySuccess',
  component: ActivitySuccessScreen,
  options: { headerShown: false, title: 'Activity Success' }
}, {
  name: 'RemeasurementStart',
  component: RemeasurementStartScreen,
  options: { headerShown: false, title: 'Remeasurement Start' }
}, {
  name: 'RemeasurementSuccess',
  component: RemeasurementSuccessScreen,
  options: { headerShown: false, title: 'Remeasurement Success' }
}, {
  name: 'WhoMeasured',
  component: WhoMeasuredScreen,
  options: { headerShown: false, title: 'Who Measured' }
}, {
  name: 'AlertEscalation',
  component: AlertEscalationScreen,
  options: { headerShown: false, title: 'Alert Escalation' }
}, {
  name: 'WherebyRoomScreen',
  component: WherebyRoomScreen,
  options: { headerShown: false, title: 'Whereby Room' }
}, {
  name: 'TeleassistanceDetailScreen',
  component: TeleassistanceDetailScreen,
  options: { headerShown: false },
}]

export const CORE_SCREEN_NAMES: string[] = CORE_SCREENS.map(s => s.name);

export default function CoreNavigator() {
  return (
    <Stack.Navigator screenOptions={{ contentStyle: { backgroundColor: colorPalette.white } }}>
      {CORE_SCREENS.map((screen) => (
        <Stack.Screen
          key={screen.name}
          name={screen.name}
          component={screen.component}
          options={screen.options}
        />
      ))}
    </Stack.Navigator>
  );
}
